export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Personalized Learning Experience",
    desc: "Tailored guidance adapting to your unique learning needs, providing a customized educational journey.",
  },
  {
    id: 2,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Extensive Resource Integration",
    desc: "Access in-depth, niche answers derived from a wealth of nursing resources, enriching your understanding of diverse concepts.",
  },
  {
    id: 3,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Uninterrupted Accessibility",
    desc: "Enjoy 24/7 access to your AI teacher, offering support and guidance at your convenience for a flexible learning schedule.",
  },
];
export const awrapper = [
  {
    cover:
      "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "3,000",
    title: "SUCCESS STORIES",
  },

  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "320",
    title: "TRUSTED TUTORS",
  },
  {
    cover:
      "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "1,000",
    title: "SCHEDULES",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "587",
    title: "COURSES",
  },
];
export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/c1.png",
    coursesName: "Introduction to Healthcare Administration",
    courTeacher: [
      {
        dcover: "./images/team/team2.png",
        name: "by John Smith",
        totalTime: "50 lectures (190 hrs)",
      },
    ],
    priceAll: "$100 All Course",
    pricePer: "$15 per month",
  },
  {
    id: 2,
    cover: "../images/courses/c2.png",
    coursesName: "Enhancing Nursing Skills",
    courTeacher: [
      {
        dcover: "./images/team/team3.jpeg",
        name: "by Ram Gurung",
        totalTime: "30 lectures (125 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 3,
    cover: "../images/courses/c3.png",
    coursesName: "Health Informatics: Introduction to Technology in Healthcare",
    courTeacher: [
      {
        dcover: "./images/team/team4.jpeg",
        name: "by Saroj Nepal",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$50 All Course",
    pricePer: "$5 per month",
  },
  {
    id: 4,
    cover: "../images/courses/c4.png",
    coursesName: "Medical Coding and Billing Fundamentals",
    courTeacher: [
      {
        dcover: "./images/team/team1.png",
        name: "by Prabin Thapa Mager",
        totalTime: "20 lectures (20 hrs)",
      },
    ],
    priceAll: "$30 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 5,
    cover: "../images/courses/c5.png",
    coursesName: "Introduction to Public Health",
    courTeacher: [
      {
        dcover: "./images/team/team2.png",
        name: "by Sunil Bishowkaram",
        totalTime: "100 lectures (150 hrs)",
      },
    ],
    priceAll: "$300 All Course",
    pricePer: "$30 per month",
  },
  {
    id: 6,
    cover: "../images/courses/c6.png",
    coursesName: "Healthcare Management and Leadership",
    courTeacher: [
      {
        dcover: "./images/back1.jpg",
        name: "by Sunil Bishowkaram",
        totalTime: "200 lectures (300 hrs)",
      },
    ],
    priceAll: "$500 All Course",
    pricePer: "$80 per month",
  },
  {
    id: 7,
    cover: "../images/courses/c7.png",
    coursesName: "Introduction to Nursing Ethics",
    courTeacher: [
      {
        dcover: "./images/team/t1.webp",
        name: "by Price",
        totalTime: "20 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$2 per month",
  },
  {
    id: 8,
    cover: "../images/courses/c8.png",
    coursesName: "Health Data Analytics: Tools and Techniques",
    courTeacher: [
      {
        dcover: "./images/team/team1.png",
        name: "by Petter",
        totalTime: "80 lectures (200 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$4 per month",
  },
  {
    id: 9,
    cover: "../images/courses/c9.png",
    coursesName: "Mental Health Awareness and Support",
    courTeacher: [
      {
        dcover: "./images/team/team4.jpeg",
        name: "by Petter",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$3 per month",
  },
];

export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "Healthcare UI/UX Design",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Healthcare Art & Design",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Healthcare Computer Science",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "Healthcare History & Archeologic",
    course: "15 Courses",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Healthcare Software Engineering",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Healthcare Information Software",
    course: "60 Courses",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Health & Fitness",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Healthcare Marketing",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Healthcare Graphic Design",
    course: "80 Courses",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Healthcare Music",
    course: "120 Courses",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Healthcare Business Administration",
    course: "17 Courses",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Healthcare Web Management",
    course: "17 Courses",
  },
];

export const team = [
  {
    cover: "./images/team/team4.jpeg",
    name: "Dr. Mututu",
    work: "AI teacher, nursing expert",
  },
  {
    cover: "./images/team/t2.webp",
    name: "Dr. Michael Davis",
    work: "Clinical Nursing Expert",
  },
  {
    cover: "./images/team/team3.jpeg",
    name: "Dr. Sarah Thompson",
    work: "Public Health Advocate",
  },
  {
    cover: "./images/team/t4.webp",
    name: "Dr. James White",
    work: "Medical Research Scientist",
  },
  {
    cover: "./images/team/team1.png",
    name: "Dr. Olivia Parker",
    work: "Patient Care Innovator",
  },
  {
    cover: "./images/team/t1.webp",
    name: "Mr. Benjamin Smith",
    work: "Health Informatics Specialist",
  },
  {
    cover: "./images/team/t3.webp",
    name: "Dr. Rachel Miller",
    work: "Holistic Health Practitioner",
  },
  {
    cover: "./images/team/team2.png",
    name: "Dr. David Robinson",
    work: "Telehealth Technology Expert",
  },
];

export const price = [
  {
    name: "BASIC HEALTH PLAN",
    price: "49",
    desc: "Access essential healthcare services and resources. Ideal for individuals seeking basic health coverage.",
  },
  {
    name: "BEGINNER WELLNESS PLAN",
    price: "79",
    desc: "Take a step towards comprehensive wellness. This plan includes a range of health and fitness benefits.",
  },
  {
    name: "PREMIUM HEALTHCARE PLAN",
    price: "109",
    desc: "Experience top-tier healthcare with our Premium Plan. Enjoy advanced medical services and exclusive benefits.",
  },
  {
    name: "ULTIMATE WELLBEING PLAN",
    price: "149",
    desc: "Achieve ultimate wellbeing with our comprehensive plan. Covering all aspects of health for a fulfilling life.",
  },
];
export const faq = [
  {
    title: "How do I Enroll in Healthcare Courses?",
    desc: "To enroll in our healthcare courses, simply navigate to the course page, select the desired healthcare program, and follow the enrollment instructions provided. You'll be on your way to advancing your healthcare knowledge and skills.",
  },
  {
    title: "Where can I find information about the courses?",
    desc: "All relevant information about our healthcare courses, including curriculum details, instructors, and pricing, can be found on the respective course pages. Explore the courses section on our website for comprehensive information.",
  },
  {
    title: "What resources are available for healthcare students?",
    desc: "Healthcare students have access to a wide range of resources, including study materials, interactive quizzes, and expert guidance. Our platform is designed to support your learning journey and help you succeed in the healthcare field.",
  },
  {
    title: "How can I get support during my healthcare studies?",
    desc: "For any support or queries during your healthcare studies, our dedicated support team is available to assist you. Contact us through the provided channels, and we'll ensure a seamless learning experience for you.",
  },
  {
    title: "Is financial aid available for healthcare programs?",
    desc: "We understand the importance of education accessibility. Explore our financial aid options to see if you qualify for assistance with healthcare program fees. We strive to make quality healthcare education accessible to all.",
  },
  {
    title: "Can I access healthcare courses on mobile devices?",
    desc: "Yes, our healthcare courses are designed to be accessible on various devices, including mobile phones and tablets. Learn on the go and fit your healthcare studies into your busy schedule with our mobile-friendly platform.",
  },
];
export const blog = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2021",
    com: "3 COMMENTS",
    title: "Pursuing a Fulfilling Career in Healthcare",
    desc: "Explore the opportunities and rewards of building a successful career in healthcare. Learn about the impact you can make and the fulfilling experiences that come with a healthcare profession.",
    cover: "../images/blog/blog1.jpg",
  },
  {
    id: 2,
    type: "admin",
    date: "APR. 25, 2022",
    com: "5 COMMENTS",
    title: "Navigating the Latest Trends in Healthcare Technology",
    desc: "Stay updated on the advancements in healthcare technology. Discover how the latest innovations are shaping the future of healthcare delivery, from telemedicine to artificial intelligence.",
    cover: "../images/blog/blog5.jpeg",
  },
  {
    id: 3,
    type: "user",
    date: "MAY. 15, 2022",
    com: "10 COMMENTS",
    title: "Balancing Work and Well-being in Healthcare Professions",
    desc: "Learn effective strategies for maintaining a healthy work-life balance in healthcare professions. Discover tips for self-care and well-being while pursuing a successful career in healthcare.",
    cover: "../images/blog/blog2.jpg",
  },
  {
    id: 4,
    type: "admin",
    date: "JAN. 02, 2022",
    com: "3 COMMENTS",
    title: "Empowering Patients through Health Education",
    desc: "Explore the role of health education in empowering patients to make informed decisions about their well-being. Learn about the impact of patient education in healthcare outcomes.",
    cover: "../images/blog/blog4.webp",
  },
  {
    id: 5,
    type: "admin",
    date: "DEC. 14, 2022",
    com: "3 COMMENTS",
    title: "Innovations in Healthcare: Trends to Watch",
    desc: "Discover the latest trends and innovations that are transforming the healthcare landscape. Stay informed about breakthroughs that are shaping the future of healthcare delivery.",
    cover: "../images/header3.png",
  },
  {
    id: 6,
    type: "user",
    date: "JAN. 18, 2021",
    com: "12 COMMENTS",
    title: "The Impact of Compassionate Care in Healthcare",
    desc: "Explore the significance of compassionate care in healthcare practices. Understand how empathy and compassion contribute to positive patient outcomes and overall well-being.",
    cover: "../images/back1.jpg",
  },
];
export const testimonal = [
  {
    id: 1,
    name: "EMMA WHITE",
    post: "REGISTERED NURSE",
    desc: "Passing my nursing exams was a daunting task, but with the help of the AI teachers and study partners on this platform, I not only passed but excelled. The personalized study plans and practice exams were incredibly beneficial in my preparation.",
    cover: "./images/testimonial1.jpg",
  },
  {
    id: 2,
    name: "ALEX CARTER",
    post: "NURSING STUDENT",
    desc: "Studying for nursing exams can be overwhelming, but the AI study partner on this platform made it feel like I had a personal tutor. The interactive lessons and constant feedback were key factors in my success. I can't recommend it enough!",
    cover: "./images/testimonial3.jpeg",
  },
  {
    id: 3,
    name: "SARAH MILLER",
    post: "LICENSED PRACTICAL NURSE",
    desc: "This platform played a crucial role in my journey to becoming a licensed practical nurse. The AI teacher provided detailed explanations, and the study partner feature allowed me to collaborate with fellow students. Together, we conquered the nursing exams.",
    cover: "./images/about5.png",
  },
];
